import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";

import {PaymentStore} from "../../../../State";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {iFramePurchaseHandler} from "../../../../services/IFramePurchaseHandler.js";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";


class ArticleDetailsStyle extends StyleSheet {
    @styleRule
    currentArticle = {
        padding: "0 24px",
        display: "flex !important",
        justifyContent: "center",
        alignItems: "baseline",
        opacity: 1,
    };

    @styleRule
    title = {
        flex: 1,
        maxWidth: "fit-content",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: 14,
        fontStyle: "italic",
        color: this.themeProps.MERCHANT_3,
    };

    @styleRule
    articlePriceContainer = {
        fontSize: 12,
        paddingLeft: 8,
        color: this.themeProps.MERCHANT_2,
    };
}

@registerStyle(ArticleDetailsStyle)
@autoredraw(PaymentStore)
export class ArticleDetails extends UI.Element {
    render() {
        const {styleSheet} = this;
        const {request, response} = iFramePurchaseHandler.lastResponse || {};

        const payment = PaymentStore.load(response)[0];

        if (!payment) {
            return null;
        }

        const currentArticleInfo = request?.comment || {};

        return [
            <div className={styleSheet.currentArticle}>
                <div className={styleSheet.title}>
                    {currentArticleInfo.title}
                </div>
                <div className={styleSheet.articlePriceContainer}>
                    {payment.getAmount()}
                </div>
            </div>
        ];
    }
}
